// WebSocket Service for Real-time Updates
class WebSocketService {
    constructor() {
        this.ws = null;
        this.listeners = {};
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 3000;
    }

    connect(userId, isAdmin = true) {
        return new Promise((resolve, reject) => {
            try {
                // Use secure WebSocket in production, regular in development
                const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
                const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                const host = process.env.REACT_APP_WS_HOST || (isLocal ? 'localhost:5002' : `${window.location.host}`);
                const url = `${protocol}//${host}/ws?userId=${userId}&isAdmin=${isAdmin}`;

                this.ws = new WebSocket(url);

                this.ws.onopen = () => {
                    console.log('✅ WebSocket connected');
                    this.reconnectAttempts = 0;
                    this.emit('connected');
                    resolve();
                };

                this.ws.onmessage = (event) => {
                    try {
                        const data = JSON.parse(event.data);
                        this.emit(data.type, data.payload);
                    } catch (error) {
                        console.error('Error parsing WebSocket message:', error);
                    }
                };

                this.ws.onerror = (error) => {
                    console.error('WebSocket error:', error);
                    this.emit('error', error);
                    reject(error);
                };

                this.ws.onclose = () => {
                    console.log('🔌 WebSocket disconnected');
                    this.emit('disconnected');
                    this.attemptReconnect();
                };
            } catch (error) {
                reject(error);
            }
        });
    }

    attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            const userId = localStorage.getItem('adminSession')
                ? JSON.parse(localStorage.getItem('adminSession')).userId
                : null;
            if (userId) {
                setTimeout(() => {
                    console.log(`Attempting to reconnect... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
                    this.connect(userId);
                }, this.reconnectDelay * this.reconnectAttempts);
            }
        }
    }

    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    }

    off(event, callback) {
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
        }
    }

    emit(event, data) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => callback(data));
        }
    }

    send(type, payload) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type, payload }));
        } else {
            console.warn('WebSocket is not connected');
        }
    }

    disconnect() {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
    }
}

const wsService = new WebSocketService();
export default wsService;
